import { useState, useEffect } from 'react';

const CAL_LINK = 'ivoliq-wilhelm/demo';

export const useCalEmbed = () => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (window.Cal) { setLoaded(true); return; }
    (function (C, A, L) {
      let p = function (a, ar) { a.q.push(ar); };
      let d = C.document;
      C.Cal = C.Cal || function () {
        let cal = C.Cal; let ar = arguments;
        if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement("script")).src = A; cal.loaded = true; }
        if (ar[0] === L) { const api = function () { p(api, arguments); }; const namespace = ar[1]; api.q = api.q || []; typeof namespace === "string" ? (cal.ns[namespace] = api) && p(api, ar) : p(cal, ar); return; }
        p(cal, ar);
      };
    })(window, "https://app.cal.com/embed/embed.js", "init");
    window.Cal("init", { origin: "https://cal.com" });
    window.Cal("ui", { styles: { branding: { brandColor: "#059669" } }, hideEventTypeDetails: false, layout: "month_view" });
    setLoaded(true);
  }, []);
  return loaded;
};

export const openCalModal = () => {
  if (window.Cal) {
    window.Cal("modal", { calLink: CAL_LINK, config: { layout: "month_view" } });
  }
};
